

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';
import { BaseTransDocument } from './../entities/basetransdocument.entity';
import { BaseDocument } from './../entities/basedocument.entity';
import { EnumInvoicePaymentTypes } from './../enums';
export class Invoice extends BaseTransDocument
{   
    public TotalSum: number; 
    public TotalSumOrigin: number; 
    public PaymentStatus: EnumInvoicePaymentTypes; 
	
}



